<template>
  <div class="search-form-pane">
    <div class="search-form-pane__header">
      <h2 class="search-form-pane__title">条件を指定して{{ typeText }}を検索</h2>
      <p class="search-form-pane__buttons">
        <button
          class="search-form-pane__button search-form-pane__button--all"
          @click="reset"
        >
          <span>全ての車両を表示</span>
        </button>

        <button
          class="search-form-pane__button search-form-pane__button--reset"
          @click="reset">
          <span>リセット</span>
        </button>
      </p>
    </div>

    <search-form-section
      :type="type"
      :search="searchValue"
      :bikeList="bikeList"
      :selectedBikes="selectedBikes"
      @changeDisplacement="changeDisplacement"
      @changeMileage="changeMileage"
      @changeShop="changeShop"
      @changePriceMin="changePriceMin"
      @changePriceMax="changePriceMax"
      @updateBikeCheck="updateBikeCheck"
    />
  </div>
</template>

<script>
import {defineComponent, computed} from 'vue'
import SearchFormSection from './SearchFormPane/SearchFormSection.vue'
import {Util} from '../master.js'

export default defineComponent({
  name: 'SearchFormPane',
  components: {
    SearchFormSection,
  },
  props: {
    search: {
      type: Object,
      required: true,
    },
    bikeList: {
      type: Array,
      required: true,
      default: () => [],
    },
    selectedBikes: {
      type: Array,
      required: true,
      default: () => [],
    },
    type: {
      type: String,
      default: 'new',
    }
  },
  setup(props, context) {
    const typeText = computed(() => Util.TYPE_LABEL[props.type])
    const searchValue = computed(() => props.search)

    const changeDisplacement = (val) => {
      context.emit('changeDisplacement', val)
    }

    const changeMileage = (val) => {
      context.emit('changeMileage', val)
    }

    const changeShop = (val) => {
      context.emit('changeShop', val)
    }

    const changePriceMin = (val) => {
      context.emit('changePriceMin', val)
    }

    const changePriceMax = (val) => {
      context.emit('changePriceMax', val)
    }

    const updateBikeCheck = (val) => {
      context.emit('updateBikeCheck', val)
    }

    /**
     * リセットボタン押下時の処理
     */
    const reset = () => context.emit('reset')

    return {
      searchValue,
      typeText,
      reset,
      changeDisplacement,
      changeMileage,
      changeShop,
      changePriceMin,
      changePriceMax,
      updateBikeCheck,
    }
  },
})

</script>